module.exports = __webpack_public_path__ + "static/media/rank-head.aae120fb.png";